module.exports = __webpack_public_path__ + "static/media/chevron-double-left.65ff224d.svg";